module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-active.0642dce9.png";